module.exports = "data:image/gif;base64,R0lGODlhDAAMAIAAAAAzmf///yH5BAAHAP8ALAAAAAAMAAwAAAIWhI+pGt37QERxnhpYlpu67i0XKJZmAQA7"